import React from 'react';
import { connect } from 'react-redux';
import SummaryColumn from '@/components/SummaryColumn';
import { getBpcPayload } from '@/selectors/bpc';
import { FieldType } from '@/bpc/mf-fields/types/Field.type';
import { FIELD_OVERRIDES } from '@/bpc/overrides/fields';
import { FieldOverride } from '@/bpc/types/FieldOverride';
import { BusinessSizeLabel } from '@/bpc/overrides/fields/BusinessSizeComponent/BusinessSizeLabel';
import { BusinessSize } from '@/bpc/mf-fields/enm/BusinessSize';
const tPrefixGeneral = 'products-fe.general';
export const _OnboardingSummaryFieldComponent = ({ field, t, value, }) => {
    const contentOverride = () => {
        const fieldOverride = FIELD_OVERRIDES[field.absolutePath];
        if (fieldOverride === FieldOverride.BusinessSizeComponent) {
            const { currency, tiers = {}, rate } = (field.customConfiguration() ||
                {});
            const { from, to } = tiers[BusinessSize[value]] || {};
            return React.createElement(BusinessSizeLabel, { currency: currency, from: from, to: to, rate: rate, t: t });
        }
    };
    const content = () => {
        if (value == null) {
            return '-';
        }
        switch (field.type) {
            case FieldType.Boolean:
                return value ? t(`${tPrefixGeneral}.yes`) : t(`${tPrefixGeneral}.no`);
            case FieldType.Enum:
                return (t(field.labelForEnumValue(value)) ||
                    field.fallbackLabelForEnumValue(value));
            case FieldType.ArrayOfEnum:
                return value
                    .map(element => t(field.labelForEnumValue(element)) || field.fallbackLabelForEnumValue(element))
                    .join(', ');
            case FieldType.EncryptedString:
                return t(`${tPrefixGeneral}.encrypted_text`);
        }
        return value.toString();
    };
    if (!field.applicable()) {
        return null;
    }
    return (React.createElement(SummaryColumn, { key: field.absolutePath, title: t(field.label, {}, field.fallbackLabel), content: contentOverride() || content() }));
};
export const OnboardingSummaryFieldComponent = connect(state => ({
    payload: getBpcPayload(state),
}))(_OnboardingSummaryFieldComponent);
